import { component as defineComponent } from 'flightjs';
import withAsimov from 'app/modules/mixins/with-asimov';
import withDependentFields from 'app/modules/mixins/with-dependent-fields';

function BriefForm() {
    this.attributes({
        submitSelector: '[type="submit"]',
        fieldErrorAttr: 'data-field-error',
    });

    this.handleFieldChange = function ($element) {
        var value = $element.val() !== null ? $element.val().trim() : null;
        if (value) {
            var $field = $element.closest('.field');
            if ($field.length > 0) {
                $field.removeAttr(this.attr.fieldErrorAttr);
            }
        }
    };

    this.focusOnValidationErrors = function () {
        var errorsDetected = false;
        var self = this;
        // Checking elements with class 'required'
        $('.required').each(function () {
            var $element = $(this);
            var value = $element.val() !== null ? $element.val().trim() : null;
            if (!value) {
                var $field = $element.closest('.field');
                var constraints = $element.data('constraints');
                // Extract the mandatory error message from field configuration constraints and set it
                var errorMessage = constraints[0].NotBlank.message;
                $field.attr(self.attr.fieldErrorAttr, '');
                var $validationContainer = $('#' + $element.data('validationMessageContainer'));
                var validationContainerType = $validationContainer.data('validationType');
                if ($validationContainer.length) {
                    $validationContainer.append(
                        self.template(self.errorTemplate[validationContainerType], {
                            error_message: errorMessage, // eslint-disable-line camelcase
                        })
                    );
                }
                errorsDetected = true;
            }
        });

        if (errorsDetected) {
            this.trigger('errorsPopulated');
        }
    };

    this.template = function (template, args) {
        $.each(args, function (i, v) {
            i = '%%' + i + '%%';
            template = template.replace(i, v);
        });
        return template;
    };

    this.after('initialize', function () {
        this.errorTemplate = {
            field: this.$node.data('fieldErrorTemplate'),
            fieldset: this.$node.data('fieldsetErrorTemplate'),
        };
        /**
         * Deactivates auto save to avoid race condition of auto save
         * overriding the form post.
         */
        this.on('submit', function () {
            this.trigger('autosaveDeactivateRequested');
        });

        $('.required').on(
            'change',
            function (event) {
                var $element = $(event.target);
                this.handleFieldChange($element);
            }.bind(this)
        );
        // Call handleFieldChange initially to reset any fixed validation errors
        // if user hits back and come to this screen
        $('.required').each(
            function (index, element) {
                this.handleFieldChange($(element));
            }.bind(this)
        );

        // Check if there are any validation errors and trigger scroll, when we redirect to brief from payment failure
        if (this.$node.data('briefMissingRequiredFields')) {
            this.focusOnValidationErrors();
        }
    });
}

export default defineComponent(BriefForm, withAsimov, withDependentFields);



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/brief-form.js